const DiscreetMessage = ({ text }: { text: string }) => (
  <div className="text-center p-8 text-gray-400 italic">{text}</div>
);

export default DiscreetMessage;
